import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import FastTextArea from '../util/FastTextArea';
import FastFormQuestion from "../util/FastFormQuestion";
import FORM_QUESTIONS from '../../step7_questions.json';

export default function DataAnalysis2Form(props) {
    let programId = props.selectedProgram?.programId
    let sloId = props.selectedLearningOutcome?.sloId
    
    let step2Data = {
        summaryOfResults: "",
        reflectionOnHypothesis: "",
        interpretationOfResults: "",
        followUpQuestions: "",
        actionsForImprovement: "",
    }
    if (programId in props.step2DataStore) {
        let step2DataBySlo = props.step2DataStore[programId]
        if (sloId in step2DataBySlo) {
            step2Data = step2DataBySlo[sloId]
        }
    }

    let step4Data = {
        summaryOfResults: "",
        reflectionOnHypothesis: "",
        interpretationOfResults: "",
        followUpQuestions: "",
        actionsForImprovement: "",
    }
    if (programId in props.step4DataStore) {
        let step4DataBySlo = props.step4DataStore[programId]
        if (sloId in step4DataBySlo) {
            step4Data = step4DataBySlo[sloId]
        }
    }

    let step5Tab1Data = {
        "s5q1": "",
        "s5q2": "",
        "s5q3": "",
        "s5q4": "",
        "s5q5": "",
        "s5q14": "",
    }
    if (programId in props.step5Tab1DataStore) {
        let step5Tab1DataBySlo = props.step5Tab1DataStore[programId]
        if (sloId in step5Tab1DataBySlo) {
            step5Tab1Data = step5Tab1DataBySlo[sloId]
        }
    }

    let step5Tab2Data = {
        "s5q15": "",
        "s5q16": "",
        "s5q17": "",
        "s5q18": "",
        "s5q19": "",
        "s5q20": "",
    }
    if (programId in props.step5Tab2DataStore) {
        let step5Tab2DataBySlo = props.step5Tab2DataStore[programId]
        if (sloId in step5Tab2DataBySlo) {
            step5Tab2Data = step5Tab2DataBySlo[sloId]
        }
    }
    
    return (
        <React.Fragment>
            <Form>
                <Form.Group as={Row} className="mb-3" controlId="describe_analyze_g1">
                    <Form.Label column sm="4">
                        Department
                    </Form.Label>
                    <Col sm="8">
                        <Form.Label column sm="8">
                            {props.department.name}
                        </Form.Label>
                    </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3" controlId="describe_analyze_g1">
                    <Form.Label column sm="4">
                        Program
                    </Form.Label>
                    <Col sm="8">
                        <Form.Label column sm="8">
                            {props.selectedProgram?.name}
                        </Form.Label>
                    </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3" controlId="describe_analyze_g1">
                    <Form.Label column sm="4">
                        Theme
                    </Form.Label>
                    <Col sm="8">
                        <Form.Label column sm="8">
                            {props.theme ? props.theme.name : 'Unavailable'}
                        </Form.Label>
                    </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3" controlId="describe_analyze_g1">
                    <Form.Label column sm="4">
                        Learning Outcome
                    </Form.Label>
                    <Col sm="8">
                        <Form.Select 
                            aria-label="Select Learning Outcome"
                            onChange={props.handleLearningOutcomeChanged}
                            name={'program-' + programId + '_slo-' + sloId}
                            value={props.selectedLearningOutcome?.sloId}
                            >
                            { props.selectedProgram &&
                                props.learningOutcomes[props.selectedProgram.programId].map((slo, key) =>
                                    <option key={key} value={slo.sloId}>{slo.text}</option>
                                )
                            }
                        </Form.Select>
                    </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3" controlId="describe_analyze_g1">
                    <Form.Label column sm="4">
                        Focus Area
                    </Form.Label>
                    <Col sm="8">
                        <Form.Label column sm="8" className="w-100">
                        { props.selectedProgram &&
                                        props.step1DataStore[props.selectedProgram.programId][props.selectedLearningOutcome?.sloId]?.s1q1}
                        </Form.Label>
                    </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3" controlId="describe_analyze_g1">
                    <Form.Label column sm="4">
                        Tool used first round
                    </Form.Label>
                    <Col sm="8">
                        <Form.Label column sm="8" className="w-100">
                            {step2Data.toolDescription}
                        </Form.Label>
                    </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3" controlId="describe_analyze_g1">
                    <Form.Label column sm="4">
                        Courses assessed first round
                    </Form.Label>
                    <Col sm="8">
                        <Form.Label column sm="8" className="w-100">
                            {step2Data.coursesAssessed}
                        </Form.Label>
                    </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3" controlId="describe_analyze_g1">
                    <Form.Label column sm="4">
                        <div>Results from first round</div>
                        <span className="text-muted"></span>
                    </Form.Label>
                    <Col sm="8">
                        <Form.Label column sm="8" className="w-100">
                            {step4Data.summaryOfResults}
                        </Form.Label>
                    </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3" controlId="describe_analyze_g1">
                    <Form.Label column sm="4">
                        <div>Changes planned</div>
                        <span className="text-muted"></span>
                    </Form.Label>
                    <Col sm="8">
                        <Form.Label column sm="8" className="w-100">
                            {step5Tab1Data.s5q2}
                        </Form.Label>
                    </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3" controlId="describe_analyze_g1">
                    <Form.Label column sm="4">
                        <div>Hypothesis about the Changes</div>
                        <span className="text-muted"></span>
                    </Form.Label>
                    <Col sm="8">
                        <Form.Label column sm="8" className="w-100">
                            {step5Tab1Data.s5q4}
                        </Form.Label>
                    </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3" controlId="describe_analyze_g1">
                    <Form.Label column sm="4">
                        <div>Description of tools used second round</div>
                        <span className="text-muted"></span>
                    </Form.Label>
                    <Col sm="8">
                        <Form.Label column sm="8" className="w-100">
                            {step5Tab2Data.s5q17}
                        </Form.Label>
                    </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3" controlId="describe_analyze_g1">
                    <Form.Label column sm="4">
                        Course(s) Assessed second round
                    </Form.Label>
                    <Col sm="8">
                        <Form.Label column sm="8" className="w-100">
                            {step5Tab2Data.s5q18}
                        </Form.Label>
                    </Col>
                </Form.Group>

                <Form.Group as={Col} controlId="describe_analyze_g1">
                    <Form.Label column sm="12">
                        <FastFormQuestion 
                            text={FORM_QUESTIONS["summaryOfResults"].text}
                            required={FORM_QUESTIONS["summaryOfResults"].required}
                            />
                    </Form.Label>
                    <Row sm="12">
                        <FastTextArea
                            id="s7q1"
                            callback={props.handleS7Q1Changed}
                            text={props.stepData.s7q1}
                            rows="3"
                            disabled={props.formDisabled}
                            maxLength="2048"
                            />
                    </Row>
                </Form.Group>

                <Form.Group as={Col} controlId="describe_analyze_g1">
                    <Form.Label column sm="12">
                        <FastFormQuestion 
                            text={FORM_QUESTIONS["interpretationOfBothRounds"].text}
                            required={FORM_QUESTIONS["interpretationOfBothRounds"].required}
                            />
                    </Form.Label>
                    <Row sm="12">
                        <FastTextArea
                            id="s7q2"
                            callback={props.handleS7Q2Changed}
                            text={props.stepData.s7q2}
                            rows="3"
                            disabled={props.formDisabled}
                            maxLength="2048"
                            />
                    </Row>
                </Form.Group>

                <Form.Group as={Col} controlId="describe_analyze_g1">
                    <Form.Label column sm="12">
                        <FastFormQuestion 
                            text={FORM_QUESTIONS["followUpAndNextSteps"].text}
                            required={FORM_QUESTIONS["followUpAndNextSteps"].required}
                            />
                    </Form.Label>
                    <Row sm="12">
                        <FastTextArea
                            id="s7q3"
                            callback={props.handleS7Q3Changed}
                            text={props.stepData.s7q3}
                            rows="3"
                            disabled={props.formDisabled}
                            maxLength="1024"
                            />
                    </Row>
                </Form.Group>
            </Form>
        </React.Fragment>
    )
}